import React, { useEffect } from "react";

/** Full-page preloader; hides itself so it does not depend on deferred jQuery/theme scripts. */
const Loader = () => {
  useEffect(() => {
    const root = document.querySelector(".preloader");
    if (!root) return undefined;

    let hideTimer;
    const showTimer = window.setTimeout(() => {
      root.style.transition = "opacity 0.45s ease";
      root.style.opacity = "0";
      hideTimer = window.setTimeout(() => {
        root.style.display = "none";
      }, 450);
    }, 200);

    return () => {
      window.clearTimeout(showTimer);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, []);

  return (
    <div className="preloader">
      <div className="status"></div>
    </div>
  );
};

export default Loader;
